export default __webpack_public_path__ + "static/Plate_2x2_Teal_RGB-39144b4adec68d967ac41394606203ca.svg";